module.exports = json2Plugin

function json2Plugin() {
	require('./lib/json2')
	return {}
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/store/plugins/json2.js
// module id = 566
// module chunks = 0